(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["@ali/seo-artcle-offers"] = factory();
	else
		root["@ali/seo-artcle-offers"] = factory();
})(self, function() {
return 